/* eslint-disable react/jsx-no-bind */
/* eslint-disable react/prop-types */
import { Typography } from '@material-ui/core';
import React, { useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import CountyContext from '../../contexts/CountyContext';
import StoryContext from '../../contexts/StoryContext';
import { rdsSelect } from '../../modules/rds';
import states, { stateFIPS } from '../../modules/states';
import { toPercent } from '../../modules/text';
import BarChart from '../BarChart';
import { getRatesByState } from './data';

function AveragePriceByRace({ height = 300 }) {
  const { stateCode } = useParams();
  const [ready, setReady] = useState(false);
  const [error, setError] = useState(null);
  const [data, setData] = useState([]);
  const { countyCode, county } = useContext(CountyContext);
  const { primaryColor, secondaryColor } = useContext(StoryContext);

  useEffect(() => {
    setError(null);
    // function getRatesByState() {
    //   let whereClause = `state_fips=${stateFIPS[stateCode.toUpperCase()]}`;
    //   whereClause += composeWhereClause({});

    //   if (countyCode) {
    //     whereClause += ` AND county_fips=${countyCode}`;
    //   }

    //   return rdsTabulate('ccdc', 'county_setting_group_rate_annual', {
    //     dims: 'state',
    //     measure: 'average_rate:AVG(rate)',
    //     where: whereClause,
    //     format: 'amcharts',
    //     inject: true,
    //   }, true);
    // }

    function getMedianHouseholdIncome() {
      let dataProduct = 'acs_sams_state_wide';
      let where = `state_fips=${stateFIPS[stateCode.toUpperCase()]}`;
      if (countyCode) {
        dataProduct = 'acs_sams_county_wide';
        where += ` AND county_fips=${countyCode} AND (county_suppressed=0 OR county_suppressed=NULL) `;
      }
      return rdsSelect('3rdparty', dataProduct, {
        cols: 'inc_fam_married_hisp,inc_fam_nospouse_hisp,inc_fam_married_white_nh,inc_fam_married_black_nh,inc_fam_married_asian_nh,inc_fam_married_aina_nh,inc_fam_married_nhpi_nh,inc_fam_married_2more_nh,inc_fam_married_other_nh,inc_fam_nospouse_white_nh,inc_fam_nospouse_black_nh,inc_fam_nospouse_asian_nh,inc_fam_nospouse_aina_nh,inc_fam_nospouse_nhpi_nh,inc_fam_nospouse_2more_nh,inc_fam_nospouse_other_nh',
        where,
        format: 'amcharts',
        inject: false,
      });
    }

    if (stateCode && states[stateCode.toUpperCase()]) {
      Promise.all([getRatesByState(stateCode, countyCode), getMedianHouseholdIncome()])
        .then((responses) => {
          const rate = responses[0].parsedBody.dataProvider[0].average_rate;

          const incomes = responses[1].parsedBody.dataProvider[0];

          // RDS used to not return the value at all if there was no data for it. Now it returns 0. Fix this.
          if (incomes.inc_fam_nospouse_white_nh === 0) delete incomes.inc_fam_nospouse_white_nh;
          if (incomes.inc_fam_nospouse_black_nh === 0) delete incomes.inc_fam_nospouse_black_nh;
          if (incomes.inc_fam_nospouse_hisp === 0) delete incomes.inc_fam_nospouse_hisp;
          if (incomes.inc_fam_nospouse_asian_nh === 0) delete incomes.inc_fam_nospouse_asian_nh;
          if (incomes.inc_fam_nospouse_aina_nh === 0) delete incomes.inc_fam_nospouse_aina_nh;
          if (incomes.inc_fam_nospouse_nhpi_nh === 0) delete incomes.inc_fam_nospouse_nhpi_nh;
          if (incomes.inc_fam_nospouse_2more_nh === 0) delete incomes.inc_fam_nospouse_2more_nh;
          if (incomes.inc_fam_nospouse_other_nh === 0) delete incomes.inc_fam_nospouse_other_nh;

          if (incomes.inc_fam_married_white_nh === 0) delete incomes.inc_fam_married_white_nh;
          if (incomes.inc_fam_married_black_nh === 0) delete incomes.inc_fam_married_black_nh;
          if (incomes.inc_fam_married_hisp === 0) delete incomes.inc_fam_married_hisp;
          if (incomes.inc_fam_married_asian_nh === 0) delete incomes.inc_fam_married_asian_nh;
          if (incomes.inc_fam_married_aina_nh === 0) delete incomes.inc_fam_married_aina_nh;
          if (incomes.inc_fam_married_nhpi_nh === 0) delete incomes.inc_fam_married_nhpi_nh;
          if (incomes.inc_fam_married_2more_nh === 0) delete incomes.inc_fam_married_2more_nh;
          if (incomes.inc_fam_married_other_nh === 0) delete incomes.inc_fam_married_other_nh;

          setData([
            { groupKey: 'White', 'Married-couple families': (rate / incomes.inc_fam_married_white_nh), 'Single-parent families': (rate / incomes.inc_fam_nospouse_white_nh) },
            { groupKey: 'Black', 'Married-couple families': (rate / incomes.inc_fam_married_black_nh), 'Single-parent families': (rate / incomes.inc_fam_nospouse_black_nh) },
            { groupKey: 'Hispanic', 'Married-couple families': (rate / incomes.inc_fam_married_hisp), 'Single-parent families': (rate / incomes.inc_fam_nospouse_hisp) },
            { groupKey: 'Asian', 'Married-couple families': (rate / incomes.inc_fam_married_asian_nh), 'Single-parent families': (rate / incomes.inc_fam_nospouse_asian_nh) },
            { groupKey: 'AINA', 'Married-couple families': (rate / incomes.inc_fam_married_aina_nh), 'Single-parent families': (rate / incomes.inc_fam_nospouse_aina_nh) },
            { groupKey: 'NHPI', 'Married-couple families': (rate / incomes.inc_fam_married_nhpi_nh), 'Single-parent families': (rate / incomes.inc_fam_nospouse_nhpi_nh) },
            { groupKey: 'Multiracial', 'Married-couple families': (rate / incomes.inc_fam_married_2more_nh), 'Single-parent families': (rate / incomes.inc_fam_nospouse_2more_nh) },
            { groupKey: 'Other', 'Married-couple families': (rate / incomes.inc_fam_married_other_nh), 'Single-parent families': (rate / incomes.inc_fam_nospouse_other_nh) },
          ]);
        })
        .catch((err) => {
          setError(err);
        })
        .finally(() => {
          setReady(true);
        });
    }
  }, [stateCode, countyCode]);

  const keys = ['Married-couple families', 'Single-parent families'];
  const groupKey = 'groupKey';

  let title = 'Race and Ethnicity of Householder';
  if (county) {
    title += ` - ${county} County`;
  }

  const formatterFunction = function formatterFunction(payload) {
    // console.log(payload);
    let raceLabel = payload.payload.groupKey;
    if (raceLabel.toLowerCase() === 'multiracial'
      || raceLabel.toLowerCase() === 'other') {
      raceLabel = raceLabel.toLowerCase();
    }

    if (raceLabel === 'AINA') {
      raceLabel = 'American Indian/Alaskan Native (AINA)';
    }

    if (raceLabel === 'NHPI') {
      raceLabel = 'Native Hawaiian/Pacific Islander (NHPI)';
    }

    if (raceLabel === 'other') {
      raceLabel = 'other race';
    }

    if (payload.value) {
      return `<b>${toPercent(payload.value)}</b> of the household income for <b>${raceLabel}</b>, 
    <b>${payload.dataKey.toLowerCase().replace('for ', '')}</b>  goes to pay for child care.`;
    }
    return 'Insufficient sample size';
  };

  return (
    <>
      {error && <Typography variant="body1" color="error">{error.message}</Typography>}
      <BarChart
        valueFormatter={toPercent}
        formatterFunction={formatterFunction}
        height={height}
        ready={ready}
        data={data}
        keys={keys}
        groupKey={groupKey}
        title={title}
        colors={[primaryColor, secondaryColor]}
      />
    </>
  );
}

export default AveragePriceByRace;
